import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { meetsMinimumPlan, isSubscriptionActive, FEATURES } from '../utils/subscriptionUtils';
import { isPlatformUser as isPlatformUserCheck } from '../utils/permissions';

export const useSubscription = () => {
  const { user, activeSubscription, subscriptionPlan } = useContext(AuthContext);

  const isPlatformUser = isPlatformUserCheck(user);

  // A lapsed (expired/cancelled) subscription grants no paid access — gate as if free.
  // active/trial keep their plan rank (isSubscriptionActive covers both).
  const active = isPlatformUser || isSubscriptionActive(activeSubscription);
  const effectivePlan = active ? subscriptionPlan : 'free';

  const hasFeature = (featureKey) => {
    if (isPlatformUser) return true;
    const requiredPlan = FEATURES[featureKey];
    if (!requiredPlan) return true;
    return meetsMinimumPlan(effectivePlan, requiredPlan);
  };

  const meetsMinimum = (plan) => {
    if (isPlatformUser) return true;
    return meetsMinimumPlan(effectivePlan, plan);
  };

  return {
    plan: subscriptionPlan,
    status: activeSubscription?.status ?? null,
    expiresAt: activeSubscription?.expires_at ?? null,
    isActive: active,
    hasFeature,
    meetsMinimum,
  };
};
